<template>
    <nav class="px-2 mt-2 flex flex-col">
        <template v-for="(group, index) in menu" :key="index">
            <USeparator v-if="index > 0" class="my-3" />
            <div class="flex flex-col gap-1">
                <NuxtLink v-for="item in group" :key="item.to" :to="item.to"
                    class="flex items-center gap-2.5 rounded-lg border-l-2 px-3 py-2.5 text-sm transition-colors"
                    :class="isActive(item)
                        ? 'border-flame-500 bg-flame-500/15 font-semibold text-highlighted'
                        : 'border-transparent text-muted hover:bg-elevated hover:text-highlighted'">
                    <UIcon :name="item.icon" class="size-4 shrink-0" />
                    <span class="truncate">{{ item.label }}</span>
                </NuxtLink>
            </div>
        </template>
    </nav>
</template>

<script setup>
import { ANNOUNCEMENTS, DEMO, OPERATIONAL, SERVICES } from '#shared/utils/permissions'

const route = useRoute()
const { canAny } = useCan()

const modules = [
    {
        label: "Empresas",
        name: "Companies",
        to: "/company",
        icon: 'i-heroicons-building-office-20-solid',
        permissions: OPERATIONAL
    },
    {
        label: "Serviços",
        name: "Services",
        to: "/services",
        icon: 'i-heroicons-wrench-screwdriver-20-solid',
        permissions: SERVICES
    },
    {
        label: "Cobranças",
        name: "Charges",
        to: "/charges",
        icon: 'i-heroicons-banknotes-20-solid',
        permissions: ['charges']
    },
    {
        label: "App Jobs",
        name: "Jobs",
        to: "/jobs",
        icon: 'i-heroicons-briefcase-20-solid',
        permissions: OPERATIONAL
    },
    {
        label: "Pesquisas",
        name: "Surveys",
        to: "/surveys",
        icon: 'i-heroicons-chart-bar-20-solid',
        permissions: ['cs']
    },
    {
        label: "Anúncios",
        name: "Announcements",
        to: "/announcements",
        icon: 'i-heroicons-megaphone-20-solid',
        permissions: ANNOUNCEMENTS
    },
    {
        label: "Demos",
        name: "Demos",
        to: "/demos",
        icon: 'i-heroicons-sparkles-20-solid',
        permissions: DEMO
    }
]

const links = [
    {
        label: 'Usuários',
        to: '/users',
        icon: 'i-heroicons-user-group-20-solid',
        permissions: OPERATIONAL
    },
    {
        label: 'Log',
        to: '/log',
        icon: 'i-heroicons-clipboard-document-list-20-solid',
        permissions: ['admin']
    },
    {
        label: 'Perfil',
        to: '/god',
        icon: 'i-heroicons-user-20-solid'
    }
]

const home = [{
    label: 'Dashboard',
    icon: 'i-heroicons-home-20-solid',
    to: '/'
}]

// A UI esconde o que o usuário não pode — a barreira real é o servidor (proxy + meta.permissions)
const allowed = (items) => items.filter((item) => !item.permissions || canAny(item.permissions))

const menu = computed(() => [home, allowed(modules), allowed(links)].filter((group) => group.length))

// Dashboard só na raiz; demais itens seguem o prefixo da rota (subrotas mantêm o item aceso)
const isActive = (item) => item.to === '/' ? route.path === '/' : route.path.startsWith(item.to)
</script>
